module.exports = "/fast-coin/img/coin/anim/shine_1/shine_1_004.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_1/shine_1_004.png
// module id = 2320
// module chunks = 5